import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import {
  Row,
  Col,
  Grid,
  Panel,
  InputGroup,
  Button,
  Table,
  PanelBody,
  PanelHeader,
  FormControl,
  PanelContainer,
  Icon,
  FormGroup,
  ControlLabel,
  Form,
  Well,
} from '@sketchpixy/rubix';

import {getUserList, getServiceRegion} from '../../api/api';
import {routeUrl} from '../routeUrl';
import RoleType from '../RoleGroup/Roles/RoleType';
import {checkRole} from '../../util/RoleChecker';
import UserType from './UserType';
import ServiceType from './ServiceType';
import DatePicker from "react-datepicker";

const INVALID_DATE = 'Invalid date';
const DATE_FORMAT = 'YYYY.MM.DD';

const tableStyle = {
  tableLayout: 'fixed'
};


class UserListTable extends Component {
   constructor(props) {
      super(props);
     this.state = {
      datatables: null,
      search: {
          userType: "",
          dateFrom:  moment().add(-5, 'days').toDate(),
          dateTo:  moment().toDate(),
          query:  '',
          country: ''
      }
    };
  }

  componentDidMount() {
        let self = this;
        let datatableDom = $(ReactDOM.findDOMNode(this.dataTable));
        if ($.fn.DataTable.isDataTable(datatableDom ) ) {
           return;
        }

        let datatables = datatableDom.addClass('nowrap')
          .DataTable({
            language: { infoFiltered: "" },
            ordering: false,
            processing: true,
            serverSide: true,
            responsive: true,
            searchDelay: 2000,
            searching: false,
            ajax : function (data, callback, settings) {
               let search = self.state.search;
               let param = _.merge({}, data, search)
                getUserList(param, (err, result) => {
                   let rslt = result.users;
                   rslt.data = self.assignData(rslt.data);
                   callback(rslt);
               });
            },
            columns: [
                {title: 'Id',                   data: 'id',           name: 'id', width: '5%', className: "td-limit", orderable: false},
                {title: 'Join Date',            data: 'signupDate',   name: 'signupDate', width: '15%', className: "td-limit"},
                {title: 'Name',                 data: 'name',         name: 'name', width: '15%', className: "td-limit", orderable: false},
                {title: 'User Type',            data: 'type',         name: 'type', width: '15%', className: "td-limit", orderable: false},
                {title: 'Age',                  data: 'age',          name: 'age', width: '15%', className: "td-limit", orderable: false},
                {title: 'E-Mail',               data: 'email',        name: 'email', width: '15%', className: "td-limit"},
                {title: 'gender',               data: 'gender',  name: 'createdTime', width: '15%', className: "td-limit", orderable: false},
                {title: 'Service Type',         data: 'serviceList',  name: 'serviceList', width: '15%', className: "td-limit", orderable: false}
            ],
            rowId: 'id',
            select: true
        });

    $('#table tbody').on('click', 'tr', e => {
      let table = $('#table').DataTable();
      $(e.currentTarget).toggleClass('selected');
      let selected = table.row('.selected').data();
      this.props.onSelectRow(selected.id);
    });

    this.setState({
        datatables: datatables
     },() => {
        //self.doSearch();
     });

  }

  assignData(users) {
    return users.map(user => {
          user.signupDate      = moment(user.createdTime).format(DATE_FORMAT);
          return user
    });
  }

  doSearch = (search) => {
    this.setState({ search: search }, () => {
      this.state.datatables.ajax.reload();
    });
  }

  render() {
    return (
        <Table id="table" ref={(c) => this.dataTable = c} className="display" cellSpacing="0" width="100%" style={tableStyle}/>
    );
  }
}

class List extends Component {
  constructor(props) {
    super(props);

    this.state = {
      search: {
        userType: "",
        dateFrom:  moment().add(-5, 'days').toDate(),
        dateTo:  moment().toDate(),
        query:  '',
        country: ''
      },
      roleRegion: 'ALL',
      role: null,
      serviceRegions: [],
    };
  }

  componentDidMount() {
    Messenger.options = {
      theme: 'flat',
    };

    getServiceRegion((err, result) => {
      if (err) {
        this.props.router.push(routeUrl.login);
      } else {
        this.setState({
          serviceRegions: result.list,
        });
      }
    });

    const requiredRoles = [
      RoleType.B2C_PATIENT_LIST,
      RoleType.B2C_PATIENT_LIST_READ_ONLY,
    ];

    checkRole(requiredRoles, this.props.router);

    let roles = JSON.parse(localStorage.getItem('roles'));
    let roleRegion = 'ALL';

    requiredRoles.forEach(requiredRoleType => {
      roles.forEach(role => {
        if (role.roleType && RoleType.enumValueOf(role.roleType.name) === requiredRoleType) {
          roleRegion = role.region;
        }
      });
    });

    this.setState({
      region: (roleRegion === 'ALL' ? '' : roleRegion),
    });
  }

  doSearch = (event) => {
    event.preventDefault();
    this.userList.doSearch(this.state.search);
  }

  countryChangeHandler = (event) => {
     this.setState({ search: {...this.state.search, country: event.target.value} });
  };

  userTypeChangeHandler = (event) => {
    this.setState({ search: {...this.state.search, userType: event.target.value} });
  };

  serviceTypeChangeHandler = (event) => {
      this.setState({ search: {...this.state.search, serviceType: event.target.value} });
  };



  queryChangeHandler = (event) => {
    let query = event.target.value;
    this.setState({ search: {...this.state.search, query: query} });
  };

  handleDateToChange = (date) => {
        this.setState({ search: {...this.state.search, dateTo: date} });
  };

  handleDateFromChange = (date) => {
        this.setState({ search: {...this.state.search, dateFrom: date} });
  };


  onSelectRow = (userId) => {

  };

  render() {
    return (
        <PanelContainer noOverflow controls={false}>
          <Panel>
            <PanelHeader className='bg-pinkishred fg-white'>
              <Grid>
                <Row>
                  <Col xs={12}>
                    <h3><Icon glyph='icon-fontello-users-1' />&nbsp; User list</h3>
                  </Col>
                </Row>
              </Grid>
            </PanelHeader>
            <PanelBody>
              <Grid>
                <Row>
                  <Col xs={12}>
                    <Well>
                      <Form inline onSubmit={this.doSearch}>
                          <div className="row">
                              <div className="col-md-2">
                                    <ControlLabel style={{width: '120px'}}>Country</ControlLabel>
                              </div>
                              <div className="col-md-2">
                                  <FormControl
                                      disabled={this.state.roleRegion === 'ALL' ? false : 'disabled'}
                                      componentClass="select"
                                      onChange={this.countryChangeHandler}
                                      value={this.state.search.region}>
                                    <option value="">ALL</option>
                                    {
                                      this.state.serviceRegions.map(serviceRegion => (
                                          <option key={serviceRegion.countryId} value={serviceRegion.countryAlpha2Code}>
                                            {serviceRegion.countryAlpha3Code}
                                          </option>
                                      ))
                                    }
                                  </FormControl>
                              </div>
                              <div className="col-md-2">
                                  <ControlLabel style={{width: '120px'}}>User Type</ControlLabel>
                              </div>
                              <div className="col-md-2">
                                  <FormControl
                                      componentClass="select"
                                      onChange={this.userTypeChangeHandler}
                                      value={this.state.search.user}>
                                    <option value="">All</option>
                                    <option value={UserType.PATIENT.name}>Patient</option>
                                    <option value={UserType.THERAPIST.name}>Therapist</option>
                                      <option value={UserType.CAREGIVER.name}>Caregiver</option>
                                  </FormControl>
                              </div>
                              <div className="col-md-2">
                                  <ControlLabel style={{width: '120px'}}>Service Type</ControlLabel>
                              </div>
                              <div className="col-md-2">
                                  <FormControl
                                      componentClass="select"
                                      onChange={this.serviceTypeChangeHandler}
                                      value={this.state.search.user}>
                                      <option value="">All</option>
                                      <option value={ServiceType.CONNECT.name}>Connect</option>
                                      <option value={ServiceType.HOME.name}>Home</option>
                                      <option value={ServiceType.THERAPIST.name}>Therapist</option>
                                  </FormControl>
                              </div>
                          </div>
                          <div className="row">
                              <div className="col-md-2">
                                  <ControlLabel style={{width: '120px'}}>Join Date</ControlLabel>
                              </div>
                              <div className="col-md-2">
                                  <ControlLabel>From</ControlLabel>
                                  <DatePicker className="form-control" selected={this.state.search.dateFrom} onChange={this.handleDateFromChange} withPortal  locale="en" dateFormat="yyyy/MM/dd"/>
                              </div>
                              <div className="col-md-2">
                                  <ControlLabel>To</ControlLabel>
                                  <DatePicker className="form-control" selected={this.state.search.dateTo} onChange={this.handleDateToChange} withPortal  locale="en" dateFormat="yyyy/MM/dd"/>
                              </div>
                              <div className="col-md-2">
                                  <ControlLabel style={{width: '120px'}}>Search Word</ControlLabel>
                              </div>
                              <div className="col-md-2">
                                  <FormControl type='text' placeholder='Search Word' onChange={this.queryChangeHandler} style={{width: '120px'}}/>
                              </div>
                              <div className="col-md-2">
                                  <Button onClick={this.doSearch} className="pull-right">Search</Button>
                                </div>
                          </div>
                      </Form>
                    </Well>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <UserListTable ref={(c) => this.userList = c} onSelectRow={this.onSelectRow} />
                    <br />
                  </Col>
                </Row>
              </Grid>
            </PanelBody>
          </Panel>
        </PanelContainer>
    );
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/routes/user/List.js